/**
 * YouTube Search Client for Monochrome.
 * Primary: YouTube Data API v3 via Cloudflare Worker.
 * Fallback: Invidious via Cloudflare Worker, then Pages Function proxy.
 */

const WORKER_BASE = 'https://monochrome-remote.amitck133.workers.dev';

/**
 * Search YouTube for music tracks.
 * Tries: Worker /yt/search (YouTube API) → Worker /yt/invidious → Pages Function /yt/search
 */
export async function searchYouTube(query, maxResults = 20) {
    if (!query?.trim()) return [];

    const normalize = (tracks) =>
        tracks.map((t) => ({
            ...t,
            artists: t.artists || [t.artist],
        }));

    // 1. Primary: YouTube Data API v3 via Cloudflare Worker
    try {
        const params = new URLSearchParams({ q: query, maxResults: String(maxResults) });
        const response = await fetch(`${WORKER_BASE}/yt/search?${params}`);

        if (response.ok) {
            const data = await response.json();
            if (data.tracks?.length > 0) return normalize(data.tracks);
        }
    } catch (e) {
        console.warn('YouTube API search failed, trying Invidious:', e.message);
    }

    // 2. Fallback: Invidious via Cloudflare Worker
    try {
        const params = new URLSearchParams({ q: query });
        const response = await fetch(`${WORKER_BASE}/yt/invidious?${params}`);

        if (response.ok) {
            const data = await response.json();
            if (data.tracks?.length > 0) return normalize(data.tracks);
        }
    } catch (e) {
        console.warn('Worker Invidious failed, trying Pages Function:', e.message);
    }

    // 3. Last resort: Pages Function proxy (same-origin)
    try {
        const params = new URLSearchParams({ q: query, maxResults: String(maxResults) });
        const response = await fetch(`/yt/search?${params}`);

        if (response.ok) {
            const data = await response.json();
            if (data.tracks?.length > 0) return normalize(data.tracks);
        }
    } catch (e) {
        console.warn('All YouTube search methods failed:', e.message);
    }

    return [];
}
